'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var heading = {
  fontFamily: 'heading',
  lineHeight: 'shorter',
  fontWeight: 'semibold'
};
exports["default"] = heading;